import c from 'classnames';
import { DesignButton, Typography } from 'components';
import { FunctionComponent } from 'react';
import styles from './CTACard.module.css';

type CTACardAction = {
  label: string;
  onClick: () => Promise<void> | void;
};

type CTACardProps = {
  containerClassName?: string;
  contentContainerClassName?: string;
  label: string;
  action?: CTACardAction;
  image: string | FunctionComponent<React.SVGProps<SVGSVGElement>>;
  color?: 'purple';
};

export const CTACard = ({
  containerClassName,
  contentContainerClassName,
  label,
  action,
  image,
  color = 'purple',
}: CTACardProps) => {
  return (
    <div className={c(styles.card, styles[color], containerClassName)}>
      <div className={c(styles.contentContainer, contentContainerClassName)}>
        <Typography variant='heading-m'>{label}</Typography>
        {action ? (
          <DesignButton
            label={action.label}
            color={color}
            onClick={action.onClick}
          />
        ) : null}
      </div>
      {typeof image === 'string' ? (
        <img src={image} className={styles.imageContainer} />
      ) : (
        <div className={styles.imageContainer}>{image({})}</div>
      )}
    </div>
  );
};
